<template>
  <div>
    <el-select :class="mode ? 'input__day' : 'input__night'" :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.reasontype')" filterable clearable :multiple="multiple"
      :size="size" style="width:100%">
      <el-option v-for="(reasonType,index) in reasonTypes" :key="'reasonTypes-' + index" :label="reasonType.name" :value="reasonType.id"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    name:'select-reason-type',
    props: {
        size: {
            default: 'small'
        },
        placeholder: {
            default: null,
        },
        id:{
          default: null
        },
        multiple:{
            type: Boolean,
            default: false,
        }
    },
     watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.reasonTypes && this.reasonTypes.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        reasonTypes: 'reasonType/inventory',
        mode:'MODE'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'reasonType/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)
        this.selected = e
      }
    },
  }

</script>
